import { render, staticRenderFns } from "./PartnerSection.vue?vue&type=template&id=6634841a&scoped=true&"
import script from "./PartnerSection.vue?vue&type=script&lang=js&"
export * from "./PartnerSection.vue?vue&type=script&lang=js&"
import style0 from "./PartnerSection.vue?vue&type=style&index=0&id=6634841a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6634841a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VCol,VContainer,VForm,VRow,VTextField,VTextarea})
